import Button from '@components/ui/button.vue';

import { mapMutations, mapState } from 'vuex';

export default {
  components: {
    't-button': Button,
  },
  computed: {
    ...mapState('params', ['mobile']),
  },
  mounted() {
    if (!this.mobile) {
      setTimeout(() => {
        document.querySelectorAll('.top-wave-js').forEach((item) => {
          wavify(item, {
            height: 80,
            bones: 5,
            amplitude: 45,
            color: '#F5F7FA',
            speed: 0.13,
          });
        });

        document.querySelectorAll('.bottom-wave-js').forEach((item) => {
          wavify(item, {
            height: 15,
            bones: 4,
            amplitude: 70,
            color: '#F5F7FA',
            speed: 0.12,
          });
        });
      }, 100);
    }
  },
  methods: {
    ...mapMutations('params', [
      'toggleRightMenu',
      'toggleFastbuy',
      'setFastBuymessage',
    ]),
    send: function(value, id) {
      this.toggleRightMenu();
      this.toggleFastbuy();
      this.setFastBuymessage({ value, id });
    },
  },
};



// WEBPACK FOOTER //
// ./src/templates/components/sales-item/script.js